import { render, staticRenderFns } from "./main-loader-screen.vue?vue&type=template&id=a3513bca&scoped=true&"
import script from "./main-loader-screen.vue?vue&type=script&lang=js&"
export * from "./main-loader-screen.vue?vue&type=script&lang=js&"
import style0 from "./main-loader-screen.vue?vue&type=style&index=0&id=a3513bca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3513bca",
  null
  
)

export default component.exports